<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Labelentries") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'labelEntry.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      /> -->
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
        :filterCols="filterCols"
        :filters="filters"
        v-on:filter="
          filters = $event;
          getData();
        "
      >
        <template v-slot:item.real_number="{ item }">
          <p :title="'ID: ' + item.id">
            {{ item.real_number }}
            <v-tooltip bottom v-if="item.info">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  mdi-information
                </v-icon>
              </template>
              <span>{{ item.info }}</span>
            </v-tooltip>
          </p>
        </template>
        <template v-slot:item.orderline.door_type.code="{ item }">
          <template v-if="item.orderline && item.orderline.door_type">
            {{ item.orderline.door_type.code }}
          </template>
          <template v-else>
            ---
          </template>
        </template>
        <template v-slot:item.orderline.order.customer.company.name="{ item }">
          <template
            v-if="
              item.orderline &&
                item.orderline.order &&
                item.orderline.order.customer &&
                item.orderline.order.customer.company
            "
          >
            {{ item.orderline.order.customer.company.name }}
          </template>
          <template v-else>
            ---
          </template>
        </template>
        <template v-slot:item.orderline.order.number="{ item }">
          <template v-if="item.orderline && item.orderline.order">
            <router-link
              :to="{
                name: 'order.edit',
                params: { id: item.orderline.order.id }
              }"
              target="_blank"
              :title="
                (item.orderline.order.number
                  ? item.orderline.order.number + ' | '
                  : '') + item.orderline.order.project
              "
              >{{
                item.orderline.order.number
                  ? item.orderline.order.number + " | "
                  : ""
              }}{{
                item.orderline.order.project | truncate(10, "...")
              }}</router-link
            >
          </template>
          <template v-else>
            ---
          </template>
        </template>
        <!-- <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template> -->
      </advanced-data-table>
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";

import axios from "axios";
var cancel;
var CancelToken = axios.CancelToken;

export default {
  name: "app-labelEntry-list",
  data() {
    return {
      loading: true,
      options: {},
      total: 0,
      search: "",
      items: [],
      filters: []
    };
  },

  created() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      if (cancel != undefined) {
        cancel();
      }
      let response = await fetchItems(
        {
          ...this.options,
          search: this.search,
          filters: this.filters
        },
        new CancelToken(function executor(c) {
          cancel = c;
        })
      );
      this.items = response.data;
      this.total = response.meta.total;
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Labelentry?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "labelEntry.edit", params: { id: url } });
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("real_number"),
          align: "left",
          value: "real_number",
          sortable: true
        },
        {
          text: this.$t("label_type"),
          align: "left",
          value: "labelType.name",
          sortable: false
        },
        {
          text: this.$t("stock_entry_date"),
          align: "left",
          value: "stock_entry_date",
          sortable: true
        },
        {
          text: this.$t("shipping_date"),
          align: "left",
          value: "shipping_date",
          sortable: true
        },
        {
          text: this.$t("Doortype"),
          align: "left",
          value: "orderline.door_type.code",
          sortable: false
        },
        {
          text: this.$t("Order"),
          align: "left",
          value: "orderline.order.number",
          sortable: false
        },

        {
          text: this.$t("Member"),
          align: "left",
          value: "orderline.order.customer.company.name",
          sortable: false
        },
        { text: "", value: "action", sortable: false }
      ];
    },
    filterCols() {
      return [
        {
          title: this.$t("real_number"),
          name: "real_number",
          type: "text"
        },
        {
          title: this.$t("label_type"),
          name: "labelType.name",
          type: "text"
        },
        {
          title: this.$t("order_number"),
          name: "orderline.order.number",
          type: "text"
        }
      ];
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
